window.DoctypePrefs = {
	
	edit: function(doctype, action){
		
		var formId = "prefsDoctypeForm";
		var docNames = Persistent.get('docNames', true);
		
		var options = {
			title	: Loc.g("Modification de numérotation de")+" "+docNames[doctype],
			buttons	: [
                {text : Loc.g('Annuler'), click : function(){$(this).dialog("close")}},
                {text : Loc.g('Enregistrer'), click : function(){$("#"+formId).submit();}}
			],
			callback	: function(){DoctypePrefs.prepareEditForm(action);}
		};
		
		MyWindow.load(action, {'action':"numDocForm", 'doctype':doctype}, options);
	},
	
	prepareEditForm: function(action){
		var formId = "prefsDoctypeForm";
		
		var options = {success:function(data){DoctypePrefs.recordEditCallback(data);}, dataType:"json"};
		var params = {action : 'numDocRecord'};
		MyForm.prepare(formId, action+"&"+$.param(params), options, true);
		MyFacture.initEvent();
		DoctypePrefs.updateExample();
		$('select').change(function(){DoctypePrefs.updateExample();});
		$('input').on('keyup', function(){DoctypePrefs.updateExample();});

	},
	
	recordEditCallback: function(data){
		var formId = "prefsDoctypeForm";
		var formIsOk = MyForm.processJson(data, formId);
		if(formIsOk){
			Utils.reload();
		}
	},
	
	updateExample : function(){
		var style = $('#prefDoctype_v1_style').val();
		var root = $('#prefDoctype_v1_root').val();
		var glue = $('#prefDoctype_v1_glue').val();
		var glueList = Persistent.get('glues', true);

		var dateformat = $('#prefDoctype_v1_dateformat').val();
		var counter = $('#prefDoctype_identcounter').val();
		
		while (counter.length < 5){
			counter = '0'+counter;
		}
		
		var date = new Date();
		var day = date.getDate() < 10 ? '0'+date.getDate(): ''+date.getDate();
		var month = (date.getMonth()+1) < 10 ? '0'+(date.getMonth()+1) : ''+(date.getMonth()+1);
		var fullYear = ''+date.getFullYear();
		var year = fullYear.slice(2,4);

		var dateForExample = '';
		
		switch(dateformat){
			case 'Ymd':
				dateForExample = fullYear + month + day;
				break; 
			case 'dmY':
				dateForExample = day + month + fullYear;
				break; 
			case 'mdY':
				dateForExample = month + day + fullYear;
				break; 
			case 'Ym':
				dateForExample = fullYear + month;
				break; 
			case 'Y':
				dateForExample = fullYear;
				break; 
			case 'yy':
				dateForExample = year;
				break;
			case 'yym':
				dateForExample = year + month;
				break; 
			case 'yymd':
				dateForExample = year + month + day;
				break; 
		}
		
		
		var identFormatForExample = new Array();
		switch (style){
			case  'rootdatenum':
				identFormatForExample = [root, dateForExample, counter];
			break;
			case  'rootnumdate':
				identFormatForExample = [root, counter, dateForExample];
			break;
			case  'daterootnum':
				identFormatForExample = [dateForExample, root, counter];
			break;
			case  'datenumroot':
				identFormatForExample = [dateForExample, counter, root];
			break;
		}
		
		var reg = new RegExp(glueList[glue]+glueList[glue], 'g')
		$('#identFormatExample').html(identFormatForExample.join(glueList[glue]).replace(glueList[glue]+glueList[glue], glueList[glue]));
	}
	
};
